<div class="pb-[40px]">
  <div class="flex justify-between items-center mr-[50px] mb-[9px] mt-[20px]">
    <p class="invitation-tinder-title">{{labels.title}}</p>
    <div class="flex justify-start items-center">
      <button type="button" (click)="handleClose()" class="close-btn">
        Close
      </button>
      <button
        type="button"
        (click)="navigateToClarification()"
        class="clarification-button"
      >
        Clarifications
      </button>
      <button
        type="button"
        class="save-button !bg-[#E76B3F] !text-[#ffffff] !text-[16px]"
        (click)="handleApplySubmission('technical')"
      >
        {{
          (tendererResponse?.project_management ||
            tendererResponse?.site_preparation) &&
          tendererResponse?.applied_technical_submission
            ? "Technical Submission"
            : "Technical Submission"
        }}
      </button>
      <button
        type="button"
        class="save-button !bg-[#E76B3F] !text-[#ffffff] !text-[16px]"
        (click)="handleApplySubmission('commercial')"
      >
        {{
          (tendererResponse?.project_management ||
            tendererResponse?.site_preparation) &&
          tendererResponse?.applied_commercial_submission
            ? "Commercial Submission"
            : "Commercial Submission"
        }}
      </button>
    </div>
  </div>

  <div class="mx-[50px] mt-[24px]">
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[30px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Project Brief</p>
    </div>
    <div class="w-[100%] pb-[30px] pt-[0px]">
      <div class="!pl-[16px]">
        <app-project-brief></app-project-brief>
      </div>
      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Selected Work Packages</p>
      </div>

      <div class="w-[50%] mt-[7px] ml-[12px]">
        <div
          class="w-[100%] flex justify-between items-center"
          *ngFor="let wp of selectedWp"
        >
          <div class="flex justify-start">
            <img
              src="assets/icons/checkbox.png"
              class="h-[20px] w-[20px] mr-[12px]"
              alt="checkbox"
            />
            <p class="packages-name !mb-0">{{ wp?.name }}</p>
          </div>
        </div>

        <div
          class="w-[100%] flex justify-between items-center"
          *ngIf="selectedWp.length === 0"
        >
          <p>No work package selected</p>
        </div>
      </div>

      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">{{labels.title}}</p>
      </div>
      <div
        class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 pl-[14px]"
      >
        <div class="flex items-center">
          <div
            class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
          >
            Tender submission deadline
          </div>
          <div
            class="text-black font-roboto pl-5 text-[14px] font-normal leading-normal"
            [innerHTML]="
              submittedData?.submission_deadline
                ? formatDate(submittedData?.submission_deadline)
                : ''
            "
          ></div>
        </div>

        <div class="flex items-center">
          <div
            class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
          >
            Submissions Address
          </div>
          <div
            class="text-black pl-5 font-roboto text-[14px] font-normal leading-normal"
          >
            {{ submittedData?.submission_address }}
          </div>
        </div>
      </div>
    </div>
    <!-- Contractual Terms -->
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Contractual Terms</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 pl-[14px]">
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Contract Type
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.contract_type_details
              ? submittedData?.contract_type_details
              : "Not Added"
          }}
        </div>
      </div>
      <!-- Attachments  -->
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Attachment
        </div>
        <!-- Download attachment -->
        <div class="flex flex-col space-y-2">
          <a
            *ngFor="let attachment of developerContractualTermsAttachments"
            class="flex items-center space-x-2"
            [ngClass]="{
              'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                developerContractualTermsAttachments,
              'text-black font-roboto text-[14px] font-normal leading-normal':
                !developerContractualTermsAttachments
            }"
            #downloadContractTermsDocumentLink
            [href]="docUrl || '#'"
            (click)="
              downloadContractTermsDocument(
                $event,
                downloadContractTermsDocumentLink,
                attachment?.id,
                attachment?.path
              )
            "
          >
          <img
          [src]="getFileIcon(attachment)"
          alt="File Preview"
          class="object-cover w-5 h-5 cursor-pointer"
        />
        
        <span>{{ attachment?.name }}</span>
          </a>
        </div>
      </div>
    </div>
    <!-- Key Date -->
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Key Dates</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 pl-[14px]">
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Issue Date
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.issue_date
              ? (submittedData?.issue_date | date : "yyyy-MM-dd")
              : "Not yet added"
          }}
        </div>
      </div>
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Clarification Deadline
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.clarification_deadline
              ? (submittedData?.clarification_deadline | date : "yyyy-MM-dd")
              : "Not yet added"
          }}
        </div>
      </div>

      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Tender Submission Deadline
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.submission_deadline
              ? (submittedData?.submission_deadline | date : "yyyy-MM-dd")
              : "Not yet added"
          }}
        </div>
      </div>

      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Contract Award Notification
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.contract_award_notification
              ? (submittedData?.contract_award_notification
                | date : "yyyy-MM-dd")
              : "Not yet added"
          }}
        </div>
      </div>
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto !text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Contract Start Date
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.contract_start_date
              ? (submittedData?.contract_start_date | date : "yyyy-MM-dd")
              : "Not yet added"
          }}
        </div>
      </div>
      <div class="flex items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto !text-[16px] font-semibold leading-normal !w-[240px]"
        >
          Project Completion Date
        </div>
        <div
          class="text-black font-roboto text-[14px] pl-5 font-normal leading-normal"
        >
          {{
            submittedData?.project_completion_date
              ? (submittedData?.project_completion_date | date : "yyyy-MM-dd")
              : "Not yet added"
          }}
        </div>
      </div>
    </div>

    <div
      class="header h-[3.438rem] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">{{labels.rfpMode}} Form</p>
    </div>
    <div class="!ml-[16px]">
      <app-itt-applicant-read-only-form
        [tendererResponse]="tendererResponse"
        [isShowRfpSubmitBtn]="true"
        [btnDisable]="
          tendererResponse?.tenderer_name !== null &&
          tendererResponse?.tenderer_position !== null &&
          tendererResponse?.tenderer_company_name !== null &&
          tendererResponse?.tenderer_contact_information !== null
            ? false
            : true
        "
      ></app-itt-applicant-read-only-form>
    </div>
  </div>

  <ng-template #dialogTemplate class="relative">
    <!-- ITT Tenderer-sections -->
    <app-itt-section-dialogs
      [submissionType]="submissionType"
      [tendererResponse]="tendererResponse"
      (closeModalEvent)="handleDialog()"
    ></app-itt-section-dialogs>
  </ng-template>
</div>
